var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaneta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Caneta"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.68799 17.0208L6.89811 15.3312C7.1674 15.2231 7.30204 15.169 7.42801 15.0985C7.5399 15.0358 7.64657 14.9635 7.7469 14.8822C7.85985 14.7908 7.96186 14.6843 8.16587 14.4714L16.7236 5.54167C17.5616 4.66722 17.5616 3.24945 16.7236 2.375C15.8856 1.50055 14.5269 1.50055 13.6889 2.375L5.13115 11.3048C4.92714 11.5177 4.82513 11.6241 4.73748 11.742C4.65963 11.8467 4.5903 11.958 4.53024 12.0747C4.46262 12.2062 4.41084 12.3467 4.30726 12.6277L2.68799 17.0208ZM2.68799 17.0208L4.24944 12.7846C4.36118 12.4815 4.41705 12.3299 4.51287 12.2605C4.59662 12.1998 4.70024 12.1768 4.80038 12.1968C4.91497 12.2196 5.02501 12.3345 5.24511 12.5641L6.95904 14.3526C7.17913 14.5822 7.28918 14.6971 7.31106 14.8166C7.33018 14.9211 7.30819 15.0292 7.25004 15.1166C7.18351 15.2166 7.03825 15.2749 6.74774 15.3915L2.68799 17.0208Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaneta);
export default __webpack_public_path__ + "static/media/Caneta.ba07c8ddf79f908a08848ae4a8c05fe5.svg";
export { ForwardRef as ReactComponent };